import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { SimulationService } from '@services';
import { LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'bo-timer',
  templateUrl: './timer.component.html',
  standalone: true,
  imports: [CommonModule, LottieComponent],
  animations: [
    trigger('moveToTopLeft', [
      state(
        'centered',
        style({
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%) scale(6)',
          width: '56px',
          height: '56px',
        }),
      ),
      state(
        'topLeft',
        style({
          top: '0px',
          left: '24px',
          width: '56px',
          height: '56px',
          transform: 'translate(0, 0)',
          opacity: '0',
        }),
      ),
      transition('centered => topLeft', animate('0.5s 1s ease-in-out')),
    ]),
    trigger('moveToCenter', [
      state(
        'topLeft',
        style({
          top: '0px',
          left: '24px',
          width: '56px',
          height: '56px',
          transform: 'translate(0, 0)',
          opacity: '0',
        }),
      ),
      state(
        'centered',
        style({
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%) scale(6)',
          width: '56px',
          height: '56px',
        }),
      ),
      transition('topLeft => centered', animate('0.5s ease-in-out')),
    ]),
  ],
})
export class TimerComponent {
  constructor() {
    effect(() => {
      if (this.simulationService.isExerciseStarted()) {
        setTimeout(() => {
          this.showAnimation = true;
          this.animationState = 'topLeft';
        }, 2500);
      }
      if (this.simulationService.isExerciseStopped()) {
        this.animationState = 'centered';
        setTimeout(() => {
          this.showAnimation = false;
        }, 3000);
      }
    });
  }

  protected simulationService = inject(SimulationService);

  animationState = 'centered';
  showAnimation = false;
  animationTimeout: number;

  recordingTime = this.simulationService.recordingTimeString;
}
